// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Check: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 9 7">
            <path
                fill="currentColor"
                fillRule="nonzero"
                d="m3.693 6.863 5.175-5.398a.484.484 0 0 0 0-.664L8.232.137a.437.437 0 0 0-.637 0L3.375 4.54l-1.97-2.055a.437.437 0 0 0-.637 0l-.636.664a.484.484 0 0 0 0 .664l2.925 3.05c.176.184.46.184.636 0Z"
            />
        </svg>
    );
};

export default React.memo(Check);
